import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/Carousel";

interface PropertyCardSkeletonProps {
  isFeatured?: boolean;
}
export const PremiumPropertyCardSkeleton = () => {
  return (
    <li className="flex border rounded-md border-gray-200 text-gray-900 group bg-zinc-50 w-full min-w-full flex-col animate-pulse">
      {/* Header */}
      <div className="rounded-t-md bg-gray-200 flex w-full justify-between h-14 p-2 px-4">
        {/* Agency logo skeleton */}
        <div className="h-full w-28 bg-gray-300 rounded-md" />

        <div className="flex gap-2 items-center">
          {/* Agent name skeleton */}
          <div className="h-4 w-32 bg-gray-300 rounded mt-3" />
          {/* Agent photo skeleton */}
          <div className="h-16 w-16 rounded-full mt-12 z-20 bg-gray-300 ring-2 ring-white" />
        </div>
      </div>

      {/* Image carousel skeleton */}
      <div className="max-h-[400px] overflow-hidden">
        <Carousel className="w-full h-[400px] relative">
          <CarouselContent>
            <CarouselItem>
              <div className="p-0">
                <div className="w-full h-[400px] bg-gray-300" />
              </div>
            </CarouselItem>
          </CarouselContent>
        </Carousel>
      </div>

      {/* Content */}
      <div className="text-gray-700 p-4 flex flex-col gap-2">
        {/* Price and actions */}
        <div className="flex justify-between items-center">
          <div className="h-6 w-32 bg-gray-300 rounded" />
          <div className="flex gap-2">
            <div className="h-6 w-6 bg-gray-300 rounded" />
            <div className="h-6 w-6 bg-gray-300 rounded" />
          </div>
        </div>

        {/* Location */}
        <div className="flex flex-col">
          <div className="flex items-center gap-1">
            <div className="h-5 w-48 bg-gray-300 rounded" />
          </div>

          {/* Property details */}
          <div className="flex items-center gap-2 mt-2">
            <div className="h-5 w-16 bg-gray-300 rounded" />
            <div className="h-5 w-2 bg-gray-300 rounded" />
            <div className="h-5 w-16 bg-gray-300 rounded" />
            <div className="h-5 w-2 bg-gray-300 rounded" />
            <div className="h-5 w-24 bg-gray-300 rounded" />
            <div className="h-5 w-2 bg-gray-300 rounded" />
            <div className="h-5 w-20 bg-gray-300 rounded" />
          </div>
        </div>

        {/* Contact buttons */}
        <div className="flex items-center gap-2 justify-end">
          <div className="h-9 w-9 rounded-full bg-gray-300" />
          <div className="h-9 w-9 rounded-full bg-gray-300" />
        </div>
      </div>
    </li>
  );
};

export const PropertyCardSkeleton = ({
  isFeatured,
}: PropertyCardSkeletonProps) => {
  return (
    <li className="flex border rounded-md border-gray-200 text-gray-900 group w-full min-w-full flex-row lg:flex-col lg:max-h-[250px] overflow-hidden animate-pulse">
      <div className="overflow-hidden text-gray-700 p-4 grid grid-cols-1 lg:grid-cols-[40%_60%] gap-2">
        <div className="relative">
          {isFeatured && (
            <div className="absolute top-0 left-0 z-10 rounded-t-md bg-gray-200 flex w-full justify-between h-10 px-1 items-center">
              <div className="h-8 w-20 bg-gray-300 rounded-md absolute" />
            </div>
          )}

          <Carousel className="relative max-h-[200px] overflow-hidden rounded-md">
            <CarouselContent>
              <CarouselItem>
                <div className="p-0">
                  <div className="w-full h-[200px] bg-gray-300 rounded-md" />
                </div>
              </CarouselItem>
            </CarouselContent>
          </Carousel>
        </div>

        <div className="text-gray-700 p-4 flex flex-col gap-2 justify-between">
          <div>
            <div className="flex justify-between items-center">
              <div className="h-6 w-32 bg-gray-300 rounded" />
              <div className="flex gap-2">
                <div className="h-6 w-6 bg-gray-300 rounded" />
                <div className="h-6 w-6 bg-gray-300 rounded" />
              </div>
            </div>

            <div className="flex flex-col mt-2">
              <div className="flex items-center gap-1">
                <div className="h-5 w-48 bg-gray-300 rounded" />
              </div>

              <div className="flex items-center gap-2 mt-2">
                <div className="h-5 w-12 bg-gray-300 rounded" />
                <div className="h-5 w-2 bg-gray-300 rounded" />
                <div className="h-5 w-12 bg-gray-300 rounded" />
                <div className="h-5 w-2 bg-gray-300 rounded" />
                <div className="h-5 w-24 bg-gray-300 rounded" />
                <div className="h-5 w-2 bg-gray-300 rounded" />
                <div className="h-5 w-16 bg-gray-300 rounded" />
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2 justify-end">
            <div className="h-9 w-9 rounded-full bg-gray-300" />
            <div className="h-9 w-9 rounded-full bg-gray-300" />
          </div>
        </div>
      </div>
    </li>
  );
};
